import { render, staticRenderFns } from "./PondAreaStat.vue?vue&type=template&id=bfa6da84&scoped=true"
import script from "./PondAreaStat.vue?vue&type=script&lang=js"
export * from "./PondAreaStat.vue?vue&type=script&lang=js"
import style0 from "./PondAreaStat.vue?vue&type=style&index=0&id=bfa6da84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa6da84",
  null
  
)

export default component.exports